import { useState } from 'react'
import { readStoredData } from '@/src/components/common/OnboardingForm/OnboardingForm.client'

import GettingStartedMoreDetailsForm from '@/src/components/common/OnboardingForm/3.MoreDetails/3.1.GettingStarted/index.client'
import WaitingForHCPMoreDetailsForm from '@/src/components/common/OnboardingForm/3.MoreDetails/3.2.WaitingForHCP/index.client'
import SwitchProviderMoreDetailsForm from '@/src/components/common/OnboardingForm/3.MoreDetails/3.3.SwitchProvider/index.client'
import WithHomecarePackageMoreDetailsForm from '@/src/components/common/OnboardingForm/3.MoreDetails/3.4.WithHomecarePackage/index.client'
import EmploymentMoreDetailsForm from '@/src/components/common/OnboardingForm/3.MoreDetails/3.5.Employment/index.client'

export default function MoreDetailsForm() {
  const [onboardingData] = useState(readStoredData())

  const FormFields = {
    getting_started: GettingStartedMoreDetailsForm,
    wait_funding: WaitingForHCPMoreDetailsForm,
    switch_provider: SwitchProviderMoreDetailsForm,
    with_homecare_package: WithHomecarePackageMoreDetailsForm,
    employment: EmploymentMoreDetailsForm,
  }[onboardingData.data?.['homecare_stage'] as string]

  if (!FormFields) return null

  return <FormFields />
}
